/** @jsx jsx */
/* global AnyNewsletter */
import { jsx } from "theme-ui";
import "@styles/newsletterStyles.css";
import { useDictionaryContext } from "../../context/dictionary/useDictionaryContext";
import { useSiteContext } from "../../context/site/useSiteContext";
import { DICTIONARY_MAP } from "../../carlsberg-headless/dictionary-map";

export const NPSScale = () => {
  const { get } = useDictionaryContext();
  const { currentCulture } = useSiteContext();

  const NPSScale = [
    {
      value: 0,
      link: "https://survey.survicate.com/6f71038769a9ca03/?p=anonymous&aid=0",
    },
    {
      value: 1,
      link: "https://survey.survicate.com/6f71038769a9ca03/?p=anonymous&aid=1",
    },
    {
      value: 2,
      link: "https://survey.survicate.com/6f71038769a9ca03/?p=anonymous&aid=2",
    },
    {
      value: 3,
      link: "https://survey.survicate.com/6f71038769a9ca03/?p=anonymous&aid=3",
    },
    {
      value: 4,
      link: "https://survey.survicate.com/6f71038769a9ca03/?p=anonymous&aid=4",
    },
    {
      value: 5,
      link: "https://survey.survicate.com/6f71038769a9ca03/?p=anonymous&aid=5",
    },
    {
      value: 6,
      link: "https://survey.survicate.com/6f71038769a9ca03/?p=anonymous&aid=6",
    },
    {
      value: 7,
      link: "https://survey.survicate.com/6f71038769a9ca03/?p=anonymous&aid=7",
    },
    {
      value: 8,
      link: "https://survey.survicate.com/6f71038769a9ca03/?p=anonymous&aid=8",
    },
    {
      value: 9,
      link: "https://survey.survicate.com/6f71038769a9ca03/?p=anonymous&aid=9",
    },
    {
      value: 10,
      link: "https://survey.survicate.com/6f71038769a9ca03/?p=anonymous&aid=10",
    },
  ];

  return (
    <div
      className="NPS"
      sx={{
        textAlign: "center",
        py: 4,
        px: [2, null, null, 5],
        color: "white",
        width: [null, null, "fit-content"],
        maxWidth: [null, null, "min-content"],
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        mx: "auto",
      }}
    >
      <div
        sx={{
          display: "flex",
          gap: "8px",
          justifyContent: [null, null, "space-between"],
          position: "relative",
          mb: 5,
          flexWrap: ["wrap", null, "nowrap"],
        }}
      >
        {NPSScale.map(({ link, value }) => {
          return (
            <a
              href={link}
              target="_new"
              key={`value-${value}`}
              sx={{
                boxSizing: "border-box",
                textDecoration: "none",
                height: "48px",
                width: "48px",
                backgroundColor: "rgba(45, 47, 51, 0.1);",
                borderRadius: "md",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "gray.3",
                transition:
                  "background-color 200ms ease-in-out, color 200ms ease-in-out",
                ":hover": {
                  backgroundColor: "rgba(45, 47, 51, 0.2);",
                  color: "gray.3",
                },
                ":active": {
                  borderStyle: "solid",
                  borderWidth: "2px",
                  fontWeight: "600",
                },
              }}
            >
              {value}
            </a>
          );
        })}
      </div>
      <div
        sx={{
          display: "flex",
          justifyContent: "space-between",
          color: "#2D2F33",
          fontSize: "smText",
        }}
      >
        <span>
          0 - {get(DICTIONARY_MAP.nps_module.not_likely_label, currentCulture)}
        </span>
        <span>
          10 -{" "}
          {get(DICTIONARY_MAP.nps_module.very_likely_label, currentCulture)}
        </span>
      </div>
    </div>
  );
};
